import { useState } from "react";
import Button from "@/components/common/Button";
import ManageKYCContent from "@/pages/settings/components/manage_kyc/Manage_Kyc_Content";
import SecurityQuestions from "@/pages/settings/components/manage_kyc/Security_Questions";
import ProceedButtons from "@/pages/settings/components/manage_kyc/ProceedButtons";
import Breadcrumb from "@/components/specific/Breadcrumb";

const ManageKYC = () => {
  const [activeTab, setActiveTab] = useState("kyc"); // 'kyc' or 'security'
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Define breadcrumb items for KYC
  const breadcrumbItems = [
    { title: "Security Questions", path: "/settings/manage-kyc" },
  ];

  const handleOpenModal = () => {
    setIsModalVisible(true);
  };

  return (
    <div className="text-left">
      <div className="mb-3">
        <Breadcrumb items={breadcrumbItems} />
      </div>
      <h1 className="mb-2 heading-large text-black">
        {activeTab === "kyc" ? "Manage KYC" : "Security Questions"}
      </h1>

      <div className="flex items-center justify-between gap-10">
        <div className="flex gap-2">
          <Button
            text="Manage KYC"
            customBgColor={activeTab === "kyc" ? "primary" : "white"}
            customTextColor={activeTab === "kyc" ? "white" : "primary"}
            className="w-[130px] h-[37px] text-small-xs border border-primary"
            onClick={() => setActiveTab("kyc")}
          />
          <Button
            text="Security Questions"
            customBgColor={activeTab === "security" ? "primary" : "white"}
            customTextColor={activeTab === "security" ? "white" : "primary"}
            className="w-[130px] h-[37px] text-small-xs whitespace-nowrap border border-primary"
            onClick={() => setActiveTab("security")}
          />
        </div>
        <ProceedButtons
          activeTab={activeTab}
          handleOpenModal={handleOpenModal}
        />
      </div>

      {activeTab === "kyc" ? (
        <ManageKYCContent />
      ) : (
        <SecurityQuestions
          isModalVisible={isModalVisible}
          setIsModalVisible={setIsModalVisible}
          handleOpenModal={handleOpenModal}
        />
      )}
    </div>
  );
};

export default ManageKYC;
